import {LitElement, html, css, TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import {sharedStyles} from "./SharedStyle";
import {getUserByUsername, Register} from "../services/routeService";
import {createCookie} from "../services/cookieService";
import {User} from "../models/User";

@customElement("register-component")
export class RegisterComponent extends LitElement {
    @property({ type: String }) public username: string = "";
    @property({ type: String }) public password: string = "";
    private usernameError: string = "";
    private passwordError: string = "";

    public static styles = [
        sharedStyles,
        css`
        body {
            font-family: Arial, sans-serif;
            background-color: black;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            margin: 0;
        }

        .container {
            text-align: center;
        }

        .register-text {
            color: #00FF00;
            font-size: 36px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        
        .register-form {
            max-width: 500px;
            margin: 0 auto;
        }

        .form-control {
            width: 95%;
            padding: 10px;
            margin-bottom: 10px;
            border: 1px solid #00FF00;
            color: #00FF00;
            background: black;
        }

        .btn {
            width: 100%;
            padding: 10px;
            background-color: #00FF00;
            border: none;
            cursor: pointer;
            color: black;
        }

        .btn:hover {
            background-color: #00c000;;
        }

        .login-link, .index-link {
            color: #00FF00;
            text-decoration: none;
        }

        .login-link a, .index-link a {
            color: #00c000;
        }

        .login-link a:hover, .index-link a:hover {
            color: #00FF00;
        }

        .error-message {
            width: 100%;
            padding: 5px;
            color: red;
            text-align: center;
        }
    `];

    public render(): TemplateResult {
        return html`
        <div class="container">
            <h1 class="register-text typewriter">Register</h1>
            <div class="register-form">
                <input class="form-control" type="text" placeholder="Username" .value=${this.username}
                       @input=${this.handleUsernameInput}>
                ${this.usernameError ? html`<div class="error-message">${this.usernameError}</div>` : ""}

                <input class="form-control" type="password" placeholder="Password" .value=${this.password}
                       @input=${this.handlePasswordInput}>
                ${this.passwordError ? html`<div class="error-message">${this.passwordError}</div>` : ""}
                <button class="btn" @click=${this.register}>Register</button>
                <p class="login-link">Do you already have an account? <a href="login.html">Login here</a></p>
                <p class="index-link"><a href="index.html">Return to Main Menu</a></p>
            </div>
        </div>
    `;
    }

    private async handleUsernameInput(event: Event): Promise<void> {
        const input: HTMLInputElement = event.target as HTMLInputElement;
        this.username = input.value;
        await this.validateUsername();
    }

    private handlePasswordInput(event: Event): void {
        const input: HTMLInputElement = event.target as HTMLInputElement;
        this.password = input.value;
        this.validatePassword();
    }

    private async validateUsername(): Promise<void> {
        this.usernameError = this.username ? "" : "Username is required";

        const user: User = await getUserByUsername(this.username);
        if (user) {
            this.usernameError = "Username already exists";
        }
    }

    private validatePassword(): void {
        this.passwordError = this.password ? "" : "Password is required";
    }

    private async register(): Promise<void> {
        await this.validateUsername();
        this.validatePassword();

        this.requestUpdate();
        if (!this.usernameError && !this.passwordError) {
            const response: any = await Register(this.username, this.password);

            if(response.access_token){
                createCookie("access_token", response.access_token, 1);
                document.location.pathname = "index.html";
            }
        }
    }
}
